import { close, open } from "./dom.js";

export function initSimplifiedCart() {
  const cartIcon = document.querySelector(".header__cart");
  const preview = document.querySelector(".simplified-cart");

  if (!cartIcon || !preview) {
    return;
  }

  cartIcon.addEventListener("mouseenter", () => open(preview));
  cartIcon.addEventListener("mouseleave", () => close(preview));
}
